<template>
  <ResponsiveLayout
    sticky-actions
    :progress="1"
    :show-kaia-logo="false"
    :show-lang-picker="false"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_quiz_cat_completed_title') }}
      </div>
    </template>

    <div class="kds-content-block">
      <img
        class="icon"
        src="@shared/assets/img/b2b/union-icon.svg"
      />
      <p class="kds-typography-display-small kds-typography-center">
        {{ $t(catSummary.summary.title) }}
      </p>

      <div class="score">
        <div class="summary">
          <span
            :class="catSummary.summary.group"
            data-qa="cat-score"
          >
            {{ catSummary.score }}
          </span>
          {{ $t('b2b_quiz_cat_of') }} 40
        </div>
        <p class="graphic">
          <img src="@shared/assets/img/cat-score.svg" />
          <span>{{ $t('b2b_quiz_cat_legend_0') }}</span>
          <span>{{ $t('b2b_quiz_cat_legend_40') }}</span>
        </p>
      </div>

      <div
        v-for="(item, index) in catSummary.summary.recommendations"
        :key="index"
      >
        <p class="kds-typography-title-medium">{{ $t(item.title) }}</p>
        <p class="kds-typography-paragraph-large">
          {{ $t(item.recommendation) }}
        </p>
      </div>
    </div>
    <template #actions>
      <BaseButton
        data-qa="submit"
        @click="nextSurvey"
      >
        {{ $t('generic_action_continue') }}
      </BaseButton>
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import useAssessmentStore from '@shared/modules/assessment/stores/useAssessmentStore.js'
import useCATStore from '@shared/modules/assessment/stores/useCATStore.js'

const router = useRouter()
const assessmentStore = useAssessmentStore()
const catStore = useCATStore()

const catSummary = computed(() => catStore.catSummary)

const nextSurvey = () => {
  assessmentStore.completeQuestionnaire(router)
}
</script>

<style lang="scss" scoped>
.icon {
  display: block;
  margin: 0 auto;
}

.score {
  .summary {
    @include kds-typography-title-xlarge;
    text-align: center;

    .low {
      color: $kds-color-text-on-green;
    }
    .medium {
      color: $kds-color-text-on-blue;
    }
    .high {
      color: $kds-color-text-on-yellow;
    }
    .very-high {
      color: $kds-color-text-on-orange;
    }
  }

  .graphic {
    img {
      max-width: 100%;
    }
    span {
      @include kds-typography-ui-subtle-medium;
      text-align: left;
      display: inline-block;
      width: 50%;
    }
    span:last-child {
      text-align: right;
    }
  }

  &__max {
    margin-left: 6px;
  }
}
</style>
